/** API 認証に失敗した場合のエラー */
export class ApiAuthenticationFailedException extends Error {
  readonly category: string
  constructor(category: string) {
    super('API authentication failed.')
    this.category = category
  }
}

/**
 * 取引所側の設定が原因で API を利用できない状態の種別。
 * いずれも時間を置いても解消せず、ユーザーの設定変更か当方の対応が必要になる。
 */
export type ExchangeApiConfigurationReason =
  /** Bitget が Unified Account (UTA) へ移行済みで Classic API を利用できない */
  | 'bitget-unified-account'
  /** Bitget が Classic Account のままで UTA API を利用できない */
  | 'bitget-classic-account'
  /** API Key の IP 許可リストに当方の接続元が含まれていない */
  | 'ip-not-allowed'
  /** 署名検証に失敗した (認証情報の誤り、または未対応のアカウント種別) */
  | 'signature-verification-failed'

/**
 * 取引所アカウント側の設定が原因で同期できない場合のエラー。
 * リトライでは解消しないため、汎用の同期失敗とは区別して扱う。
 */
export class ExchangeApiConfigurationException extends Error {
  /** 設定不備の種別 */
  readonly reason: ExchangeApiConfigurationReason
  /** 取引所が返した原文メッセージ */
  readonly detail: string

  /**
   * 設定不備例外を生成する。
   * @param params 設定不備の種別と取引所が返した原文を受け取る。
   */
  constructor(params: {
    readonly reason: ExchangeApiConfigurationReason
    readonly detail: string
  }) {
    const { reason, detail } = params
    super(`Exchange API configuration error (${reason}): ${detail}`)
    this.name = 'ExchangeApiConfigurationException'
    this.reason = reason
    this.detail = detail
  }
}

/** API Passphrase が必須だが定義されていない場合のエラー */
export class ApiPassphraseRequiredException extends Error {
  constructor() {
    super('API Passphrase is required but not defined.')
  }
}

/** API Secret が必須だが定義されていない場合のエラー */
export class ApiSecretRequiredException extends Error {
  constructor() {
    super('API Secret is required but not defined.')
  }
}

/** symbol に一致する asset が見つからない場合のエラー */
export class AssetNotFoundException extends Error {
  constructor(symbol: string) {
    super(`Asset not found for symbol: ${symbol}`)
  }
}

/** subType が必須だが定義されていない場合のエラー */
export class SubTypeRequiredException extends Error {
  constructor() {
    super('SubType is required but not defined.')
  }
}
